import mixin from "./util/mixin";
import compose from "./util/compose";
import runConfig from "./config";
import mock from "./util/mock";
import preprocess from "./config/preprocess";
import postprocess from "./config/postprocess";
import requestType from "./middleware/requestType";
class Service {
    constructor(requester) {
        this.requester = requester;
        this.preConfig = new Map();
        this.postConfig = new Map();
        this.middlewareList = [requestType];
        this.preConfig.set("preprocess", preprocess);
        this.postConfig.set("postprocess", postprocess);
    }
    use(middleware) {
        this.middlewareList.push(middleware);
        return this;
    }
    createRequest(apiName, target, middlewareWrap, apiSchemaList, serviceConfig) {
        return function (requestObj) {
            const requestInfo = mixin(serviceConfig, apiSchemaList[apiName], requestObj);
            return middlewareWrap(requestInfo, (ctx) => {
                const { config } = ctx;
                let request = runConfig.pre(config, target.preConfig, Promise.resolve(ctx), ctx);
                request = request.then(() => {
                    if (process.env.NODE_ENV === "development") {
                        const mockData = mock(ctx);
                        if (mockData) {
                            return mockData;
                        }
                    }
                    return target.requester(ctx);
                });
                return runConfig.post(config, target.postConfig, request, ctx);
            });
        };
    }
    generator(apiSchemaList, dynamicServices, serviceConfig) {
        const middlewareWrap = compose(this.middlewareList);
        const services = Object.create(null);
        if (dynamicServices) {
            Object.keys(dynamicServices).forEach((key) => {
                services[key] = dynamicServices[key];
            });
        }
        const self = this;
        if (typeof Proxy === "undefined") {
            Object.keys(apiSchemaList).forEach((apiName) => {
                services[apiName] = this.createRequest(apiName, this, middlewareWrap, apiSchemaList, serviceConfig);
            });
            return services;
        }
        else {
            return new Proxy(services, {
                get(target, propertyKey) {
                    if (propertyKey in target) {
                        return target[propertyKey];
                    }
                    if (propertyKey in apiSchemaList) {
                        return self.createRequest(propertyKey, self, middlewareWrap, apiSchemaList, serviceConfig);
                    }
                },
                set(target, propertyKey, value, receiver) {
                    if (propertyKey in apiSchemaList) {
                        if (process.env.NODE_ENV === "development")
                            console.error(`can not set property ${propertyKey}`);
                        return false;
                    }
                    else {
                        return Reflect.set(target, propertyKey, value, receiver);
                    }
                },
            });
        }
    }
}
export default Service;
